import { css } from 'styled-components';
import { Dots, PaginationWrapper } from '../../../../components/Pagination/styles';
import spacing from '../../../../helpers/spacing';
import { themeSpecificColors } from '../../colors';

export default css`
  ${Dots} {
    color: ${themeSpecificColors.neutral03_darker};
    font-weight: bold;
  }

  &&${PaginationWrapper} {
    margin: ${spacing(5)} 0;
  }
`;
